module.exports = __webpack_public_path__ + "img/arms_4_1.43801709.png";